import { useTranslation } from "react-i18next";
import { Toggle } from "@/components/ui";

export function MarketingConsentToggle({
  value, onChange, compact = false,
}: {
  value: boolean;
  onChange: (next: boolean) => void;
  compact?: boolean;
}) {
  const { t } = useTranslation();
  if (compact) {
    return (
      <label style={{ display: "flex", alignItems: "center", gap: 10, cursor: "pointer", fontSize: 13, color: "var(--ink-1)" }}>
        <input
          type="checkbox"
          checked={value}
          onChange={(e) => onChange(e.target.checked)}
          style={{ width: 18, height: 18, cursor: "pointer" }}
        />
        <span style={{ fontWeight: 600 }}>{t("v2.consent.opt_in_short")}</span>
      </label>
    );
  }
  return (
    <div style={{ display: "flex", alignItems: "flex-start", gap: 12 }}>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div className="display" style={{ fontSize: 14, fontWeight: 700, color: "var(--ink-1)" }}>
          {t("v2.consent.marketing_label")}
        </div>
        <div style={{ fontSize: 12, color: "var(--ink-2)", marginTop: 2, lineHeight: 1.4 }}>
          {t("v2.consent.marketing_desc")}
        </div>
      </div>
      <Toggle on={value} onChange={() => onChange(!value)} />
    </div>
  );
}
